import enMessages from './en.json';
import frMessages from './fr.json';

const translations = {
  en: enMessages,
  fr: frMessages
};

export default translations;